import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Announcing ServerlessReact.Dev – my new course on building apps from scratch",
  "description": "",
  "published": "2020-01-27T00:00:00.000Z",
  "redirect_from": ["/blog/announcing-serverlessreact-dev-my-new-course-on-building-apps-from-scratch/swizec/9309"],
  "categories": "Personal",
  "hero": "./img/techletter.app-screenshot-1580143626727.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I'm thrilled to announce my new course `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` on building webapps with the hyper productive modern stack.`}</p>
    <p>{`You're a brilliant engineer, {% if subscriber.first_name != blank %} {{ subscriber.first_name }} {% else %} my friend {% endif %}. Great at your job. Someone gives you a spec and `}<strong parentName="p">{`you get it done`}</strong>{`. Bam 💪`}</p>
    <p>{`But can you ship a product on your own?`}</p>
    <p>{`Usually you work with others. They're slow. They're busy. There's meetings. Committees. Pull requests. Managers. Approvals. So much work about work that `}<em parentName="p">{`doesn't deliver value to users`}</em>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/95e5098093fd2f02d3e5248b69568800/media-6y038xO1p06He-giphy.gif",
        "alt": "groan giphy"
      }}></img></p>
    <p>{`Every little thing involves a designer, a JavaScript expert, a CSS professional, a backend engineer, a database person, the QA team, the devops folks, the ...`}</p>
    <p>{`It takes you `}<em parentName="p">{`months`}</em>{` to turn a star button into a like button.`}</p>
    <p>{`Ugh.`}</p>
    <p>{`What if you could `}<em parentName="p">{`grab an idea by the horns`}</em>{` and `}<strong parentName="p">{`build the damn thing`}</strong>{`? Own a feature from start to finish?`}</p>
    <p>{`That's why I created `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a></p>
    <h1 {...{
      "id": "serverlessreactdev"
    }}>{`ServerlessReact.Dev`}</h1>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=L8Sx28i2NZw"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M109%203v7l-4%208c-3%205-3%206-4%2014l-1%2014%201%207c2%202%200%204-2%204-2-1-2-1-2%201l-1%203-1%203-1%204-1%202-1%204c-3%206-3%208-1%2011l3%202c2%200%204-7%204-10l1-2%201-3c0-3%204%206%206%2012l3%205%201%203v8c0%205%202%2012%204%2012l2-5c1-5%203-4%206%202l2%204c2%200%202%200%202-8%200-6%201-11%203-10l3%207c4%2012%2015%2020%2028%2020%2015%200%2025-8%2028-27%201-8%207-12%2012-7l7%2017h-8c-9%200-11%201-10%209%201%205%201%205%208%206l6%201-5%201h-17c-3%201-1%203%204%203l4%201-1%201c-1%200-3%201-3%203l-3%202c-2-2-4%202-3%205%200%204%200%204%203%204%205%200%2011-2%2014-5l2-1%205%203c6%203%205%204-6%205-5%200-11%201-16%203-7%202-8%202-10%201-2-2-4-1-4%202%200%202%2021%206%2028%205%205-1%2014%201%2015%203%200%202-7%207-13%207l-7%202-3%208h18l2-1%202-1c0-2%208-9%209-9%201%201%201%200%203-11l1-4%204-2c1-2%202-2%203-2%201%202%202%201%202-2s-1-4-5-6c-6-3-13-10-11-12%201-3%2020-1%2019%202l2%204c2%203%201%2013-3%2028-4%2013-6%2018-7%2016s-2-1-2%203c0%203-4%207-8%208l-9%204-7%202h-21l-3-2-5-2-5-1h-2l2%202%202%204%201%201%206%203c3%203%203%204%202%205v3c1%202-5%207-9%207-3%200-2%200%202%201%2010%201%208%202-6%202h-14l-7-28-5-20-11%203c-9%203-16%206-42%2019-4%202-6%203-7%206-2%204-12%2014-16%2015-3%200-3%203%201%204%202%201%202%201%200%201l-3%201-2%201c-2%201-2%201%200%201%204%200%202%203-2%204-3%200-5-3-2-4%201-1%201-1-1-1l-2%202c0%202%200%203-4%203-5%200-6-1-5-2%200-1%201-2%203-2%205%200%205-1%201-1l-6-1-21-1H0v11h401v-5c0-9%200-10-5-10-5-1-6-2-6-14v-8h10V0H109v3m85%206l-8%202c-13%203-18%206-23%2011-3%203-5%205-10%206-9%203-14%206-17%2011l-3%204v-3c0-5-1-11-2-9h-3c-1%200-2%201-3%205-3%206-3%2017%200%2028l2%2014c0%206%200%206%2011%200l15-5%208-2c6-3%2018%200%2020%205s5%206%2012%205c6-1%206-1%206-3%200-6%202-9%208-12%207-4%2014-4%2016-1%201%202%203%202%208%202%206%200%207%200%206-2%200-2-6-6-8-6-1%201-8-2-7-3l-1-1-2-1c0-2-4-3-6-2-1%201-2-1%200-4%201-3%2016%202%2022%207%202%201%202%201%202-3l-1-9c-1-9-8-21-16-27-4-3-6-4-11-5l-7-1c-2-1-7-2-8-1m-40%2048l-7%205-3%203h4c4%200%205%200%205-2%201-1%202-2%205-2%206%200%208-1%208-3l-2-1h-1c0-2-5-2-9%200m-2%2021c-4%203-5%203-3%200%202-2-1-1-5%201-11%205-14%2015-7%2027%208%2017%2027%2020%2041%207%2010-11%209-30-3-34-2-1-3%201-1%203%203%203%200%204-5%201l-2-1-2%203c-2%203-6%204-9%201h-3l-4%201c-4-1%209-7%2015-7l6-1c-1-4-13-4-18-1m60%203l-4%202c-2%201-2%201-2%207%202%2014%2011%2024%2023%2024%204%200%2015-4%2013-5v-9c2-13-2-22-6-18l-2%201-2%201-2%202c-1%200-2%200-1-1l-3-1c-7%201-10%200-11-2-1-3-3-4-3-1m29%2091c-3%207-5%2025-3%2024%201-1%203-5%207-19%201-2%200-4-1-6-1-4-1-4-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2733ee1c2a463c64599786c06af9905/ca0a1/techletter.app-screenshot-1580143626727.webp 223w", "/static/a2733ee1c2a463c64599786c06af9905/75680/techletter.app-screenshot-1580143626727.webp 445w", "/static/a2733ee1c2a463c64599786c06af9905/0ba47/techletter.app-screenshot-1580143626727.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2733ee1c2a463c64599786c06af9905/e92b6/techletter.app-screenshot-1580143626727.png 223w", "/static/a2733ee1c2a463c64599786c06af9905/e66bf/techletter.app-screenshot-1580143626727.png 445w", "/static/a2733ee1c2a463c64599786c06af9905/6af66/techletter.app-screenshot-1580143626727.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a2733ee1c2a463c64599786c06af9905/6af66/techletter.app-screenshot-1580143626727.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` is a video course that shows you how to build a modern webapp from scratch to launch using the hyper productive modern web stack.`}</p>
    <p>{`You'll learn everything you need to `}<strong parentName="p">{`become a fullstack frontend engineer.`}</strong></p>
    <p><a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` is focused on practical examples and showing you the whole process. Warts and all.`}</p>
    <p>{`When you follow a polished tutorial, you learn how to build `}<em parentName="p">{`that`}</em>{` thing. But your skills don't transfer. And when something goes wrong, you're stuck.`}</p>
    <p>{`With `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` you get a behind-the-scenes look. I'll show you how to debug problems, how to design a solution, where to start, and when to say good enough.`}</p>
    <p>{`Learn `}<strong parentName="p">{`the pragmatic way to build modern apps`}</strong>{`.`}</p>
    <p>{`We start with some theory, learn the stack, do some practical exercises to get a feel for technologies, `}<em parentName="p">{`then build a whole app`}</em>{`. From a list of features to accepting payments.`}</p>
    <h2 {...{
      "id": "whats-in-serverlessreactdev"
    }}>{`What's in ServerlessReact.Dev`}</h2>
    <p>{`ServerlessReact.Dev covers the new technologies that represent `}<strong parentName="p">{`the future of web development`}</strong>{`. Get ahead of this `}<strong parentName="p">{`exciting new paradigm shift`}</strong>{`.`}</p>
    <p>{`– Learn how to build blazing fast `}<strong parentName="p">{`static-first React apps`}</strong>{` with Gatsby`}</p>
    <p>{`– Learn how to `}<strong parentName="p">{`use GraphQL`}</strong>{` to minimize API requests`}</p>
    <p>{`– Leverage `}<strong parentName="p">{`design systems`}</strong>{` to build beautiful apps without designers`}</p>
    <p>{`– `}<strong parentName="p">{`Serverless`}</strong>{` technologies for adding functionality on the server`}</p>
    <p>{`– `}<strong parentName="p">{`Store and manage data`}</strong>{` in a database`}</p>
    <p>{`– `}<strong parentName="p">{`Payments`}</strong>{` integration`}</p>
    <p>{`– `}<strong parentName="p">{`Authenticate`}</strong>{` users and keep track of their accounts`}</p>
    <p>{`– `}<strong parentName="p">{`JAMStack`}</strong>{` deployments for production-ready frontend code`}</p>
    <p>{`– The `}<strong parentName="p">{`Edge First Architecture`}</strong>{` for frontend state management using React Hooks`}</p>
    <p>{`I want to show you everything you need to build blazing fast static-first webapps and launch a successful product on the side. And if you don't want to launch products, these techniques will streamline your workflow at the day job.`}</p>
    <p><strong parentName="p">{`YOU`}</strong>{` can build the whole thing. Whatever it is.`}</p>
    <p>{`And just this week, `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev/"
      }}>{`ServerlessReact.Dev`}</a>{` is $100 off until Jan 31st.`}</p>
    <p>{`Start owning ideas like a pro 👉 `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev/"
      }}>{`ServerlessReact.Dev`}</a></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`Swizec`}</p>
    <p>{`PS: got some questions? hit reply`}</p>
    <p>{`PPS: I built an entire new course platform just for ServerlessReact.Dev and I couldn't have done it without the modern stack`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      